import { Type } from "@angular/core";
import { SidePanelService } from "../../core/side-panel.service";
import { SidePanelStateComponent } from "../side-panel-state-component";

export enum SPSCode {CLOSED, OPENED, NEW_ITEM}

export class SidePanelState {
    
    constructor(public component : Type<SidePanelStateComponent>){}
    // readonly code : SPSCode;
    //readonly component : Type<any>;

    data : any;

    //init? : (args? : any) => void;
}